export default {"src":"/_next/static/media/Minuti.304ffe2e.svg","height":43,"width":36};